import { useCallback, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";

import {
  setLoadingType,
  setErrorType,
  openHeaderBox,
  setPasswordScreen,
} from "../../../../components/dataflow/utils-module";
import { clearFilter } from "../../../search/dataflow/search-module";
import { loginRequest } from "../../../../services/authConfig";

export function useLogin() {
  const dispatch = useDispatch();
  const { instance, inProgress } = useMsal();
  const isLoading = useSelector((state) => state.utils.isLoading);

  useEffect(() => {
    dispatch(clearFilter());
    dispatch(setPasswordScreen("password-reset"));
    dispatch(setErrorType({ type: "" }));
    dispatch(
      openHeaderBox({
        type: "",
        isOpen: false,
      })
    );
  }, [dispatch]);

  const isAzureLoading = isLoading.type === "login";

  const onFinishAzure = useCallback(() => {
    if (inProgress !== "none") return;
    dispatch(setLoadingType({ type: "login" }));
    instance.loginRedirect(loginRequest);
  }, [dispatch, inProgress, instance]);

  return {
    onFinishAzure,
    isAzureLoading,
  };
}
